import React, { Component } from 'react';
export default class Bubble extends Component {
  constructor (props) {
    super(props);
    this.state = {}
  }
  renderIKnow = () => {
    return <div className={'tooltips'} onClick={() => {
      this.props.onClick && this.props.onClick()
    }
    }>
      好了，我知道了
    </div>
  };
 render() {
   const {left,right,bottom, top, visible, showtips, rendertips} = this.props;
   let ele = rendertips || this.renderIKnow();
   return (
    <React.Fragment>
      <div className={'bubble'}
          {...this.props}
          style={{
              display: visible==='true' ? 'block': 'none',
            left,
            top,
            bottom,
            right
           }}
      >
        <section className={'text'}>{this.props.children}</section>
        {
          showtips ? ele : null
        }
      </div>

    </React.Fragment>
  )
 }
}
